import angular from 'angular';
import RwTooltipComponent from './rw-tooltip-component';

export default angular
  .module('rw-tooltip', [])
  .component('rwTooltip', new RwTooltipComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-tooltip/rw-tooltip-module.js